<template>
    <div class="wrapper">
      <div class="body">        
        <NuxtLink :to="notification.contexts.item_blog.link" class="cover">
          <img loading="lazy" :src="notification.contexts.item_blog.cover" :alt="notification.contexts.item_blog.title">
        </NuxtLink>
        <NuxtLink :to="notification.contexts.item_blog.link" class="title">
          {{ notification.contexts.item_blog.title }}
        </NuxtLink>
      </div>
<!-- 
      <div class="actions">
        <div v-if="commentBodyIsMoreThan3Lines && show_more" @click="showMore"><i class="icon-angle-top"></i> Show less</div>
        <div v-else-if="commentBodyIsMoreThan3Lines" @click="showMore"><i class="icon-angle-bottom"></i> Show more</div>
        <NuxtLink :to="notification.contexts.item_problem.link"><i class="icon-external"></i> Go to solution</NuxtLink>        
      </div>
       -->
    </div>    
  </template>
  
<script setup lang="ts">
   
const props = defineProps<{ notification: Notification }>()
   


const show_more = ref(false);

const commentBodyIsMoreThan3Lines = computed(() => {
  return props.notification.contexts.item_solution.text.split('\n').length > 3;
})

const showMore = () => {
  show_more.value = !show_more.value;
}


  </script>
  
<style scoped>
  
.wrapper{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
}
.body{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.title{
  font-weight: bold;
  font-size: 1rem;
}
.cover img{
  width: 100%;
  aspect-ratio: 3/2;
  max-width: 150px;
  object-fit: cover;
  border-radius: 5px;  
}

  
</style> 